import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import "../../styles/common/successPopup.scss";
import checkImg from "../../assets/image/checkImage.png";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const SuccessPopup = ({
  open,
  onClose,
  message = "Success!",
  duration = 1500,
  iconSrc,
  type = "success",
}) => {
  useEffect(() => {
    if (!open || !duration) return;
    const t = setTimeout(() => {
      onClose && onClose();
    }, duration);
    return () => clearTimeout(t);
  }, [open, duration, onClose]);

  if (!open) return null;

  return createPortal(
    <div
      className="success-overlay"
      role="dialog"
      aria-live="polite"
      onClick={onClose}
    >
      <div className="success-card" onClick={(e) => e.stopPropagation()}>
        <div className="popup-header">
          <h2>{type === "error" ? "Error" : "Success"}</h2>
        </div>
        <div
          className="popup-content"
          style={{ textAlign: "center", padding: "28px 24px" }}
        >
          <div className="success-icon-wrap">
            {type === "error" ? (
              <ErrorOutlineIcon
                className="success-icon"
                style={{ color: "#d92d20" }}
                fontSize="large"
                aria-hidden
              />
            ) : (
              <img
                src={iconSrc || checkImg}
                alt="success"
                className="success-icon"
              />
            )}
          </div>
          <div className="success-message">
            {typeof message === "string" ? <p>{message}</p> : message}
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default SuccessPopup;
